export const en = {
  nav: {
    home: 'Home',
    work: 'Work',
    about: 'About',
    contact: 'Contact',
    logoHome: 'Home',
  },
  language: {
    label: 'Language',
    en: 'EN',
    es: 'ES',
    switchTo: 'Switch to {language}',
  },
  theme: {
    groupLabel: 'Color theme',
    light: 'Light',
    system: 'System',
    dark: 'Dark',
    optionTitle: '{label} theme',
    cycleTitle: 'Theme: {current}. Switch to {next}.',
    cycleHidden: 'Color theme: {current}. Switch to {next}.',
  },
  meta: {
    role: 'Software Engineer',
    homeDescription:
      'David Martínez — Software Engineer. Scalable systems, performance, and reliable delivery.',
    aboutDescription:
      'Software engineer with 8+ years designing and operating scalable, highly available systems.',
    workDescription: 'Case studies and selected systems — problem, approach, and outcome.',
    contactDescription: 'For roles, collaborations, or technical conversations.',
  },
  home: {
    title: 'I design and build scalable, fault-tolerant software systems.',
    subheadline:
      'Software engineer with 8+ years shipping backend platforms, distributed services, and performance-critical paths — with a pragmatic focus on reliability, maintainability, and measurable outcomes.',
    metrics: {
      queries: 'Faster queries',
      stability: 'Operational stability',
      reliability: 'Production reliability',
      coverage: 'Test coverage',
      context: '*Outcomes from recent platform & performance work',
    },
    focusAreas: 'Focus areas',
    selectedWork: 'Selected work',
    viewWork: 'View work',
    services: [
      {
        id: 'backend',
        title: 'Backend & distributed systems',
        description:
          'Rails, Node/NestJS, microservices, and event-driven architectures built for scale and clarity.',
      },
      {
        id: 'performance',
        title: 'Performance & resilience',
        description:
          'Query optimization, async workers, queues, and caching tuned for real production load.',
      },
      {
        id: 'observability',
        title: 'Observability & quality',
        description:
          'Better monitoring, higher reliability in production, SOLID/TDD, and healthier codebases.',
      },
      {
        id: 'ai',
        title: 'AI-assisted engineering',
        description:
          'Agents, MCP, and workflows that raise team throughput without lowering the engineering bar.',
      },
    ],
  },
  about: {
    title: 'About',
    subtitleLine1: 'Building reliable systems,',
    subtitleLine2: 'and the practices that keep them that way.',
    profileTitle: 'Software Engineer',
    p1:
      'Software engineer with 8+ years designing, developing, and operating scalable, highly available systems. I care about clear architecture, pragmatic trade-offs, and shipping software that holds up in production — not just in demos.',
    p2:
      "At Rankmi I've focused on performance and platform work: making queries dramatically faster, raising operational stability through async processing, and leading a notification microservice the organization standardized on. Earlier at Asymm I owned features end-to-end and lifted quality through higher coverage and less technical debt. Lately I've also been deepening AI-assisted development, agents, and MCP to accelerate engineering workflows.",
    expertise: 'Technical expertise',
    skills: [
      {
        category: 'Backend & Architecture',
        items: [
          'Ruby on Rails',
          'Node.js',
          'NestJS',
          'REST APIs',
          'GraphQL',
          'Microservices',
          'Event-Driven Architecture',
        ],
      },
      {
        category: 'Databases',
        items: ['PostgreSQL', 'MongoDB', 'Redis', 'Data Modeling', 'Query Optimization'],
      },
      {
        category: 'Front-End',
        items: ['React', 'TypeScript', 'JavaScript (ES6+)', 'Redux', 'React Native'],
      },
      {
        category: 'Cloud & DevOps',
        items: ['AWS', 'GCP', 'Docker', 'Kubernetes', 'CI/CD'],
      },
      {
        category: 'Performance & Observability',
        items: ['Async Processing', 'Message Queues', 'Caching', 'New Relic', 'Datadog', 'Sentry'],
      },
      {
        category: 'AI Engineering',
        items: ['AI-Assisted Development', 'AI Agents', 'MCP', 'Agentic Workflows'],
      },
      {
        category: 'Engineering practices',
        items: ['System Design', 'SOLID', 'Design Patterns', 'TDD', 'Technical Leadership'],
      },
    ],
  },
  work: {
    title: 'Work',
    subtitle: 'Case Studies',
    viewCaseStudy: 'View Case Study',
    more: 'more',
    problem: 'Problem:',
    solution: 'Solution:',
    result: 'Result:',
    fallbacks: {
      problem: 'Technical challenge requiring scalable architecture.',
      solution: 'Modern architecture with clear ownership and reliability.',
      result: 'Improved performance and reliability.',
    },
  },
  contact: {
    title: 'Contact',
    subtitle: 'For roles, collaborations, or technical conversations.',
    sendEmail: 'Send an email at',
  },
  project: {
    back: 'Back to Projects',
    previous: 'Previous Project',
    next: 'Next Project',
  },
  cta: {
    getInTouch: 'Get in touch',
    interested: 'Interested? Have any questions?',
    openTo:
      'Open to engineering collaboration and roles where system design and delivery quality matter.',
  },
  notFound: {
    title: 'Page not found',
    goHome: 'Go to the front page →',
  },
};
